module.exports = __webpack_public_path__ + "img/beer_id-15.6b636f3a.png";